var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M15.9993 29.3327C23.3631 29.3327 29.3327 23.3631 29.3327 15.9993C29.3327 8.63555 23.3631 2.66602 15.9993 2.66602C8.63555 2.66602 2.66602 8.63555 2.66602 15.9993C2.66602 23.3631 8.63555 29.3327 15.9993 29.3327Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2272 17H10.5605C10.0139 17 9.56055 16.5467 9.56055 16C9.56055 15.4533 10.0139 15 10.5605 15H21.2272C21.7739 15 22.2272 15.4533 22.2272 16C22.2272 16.5467 21.7872 17 21.2272 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledMinus);
export default __webpack_public_path__ + "static/media/disabledMinus.dfc8d8fd98b321be6f9ec3f96f69d3b2.svg";
export { ForwardRef as ReactComponent };